/**
 * Checks if a repository description contains HTML tags.
 * This should only be used for repository descriptions, which have '<' and '>' entities escaped when not
 * used as part of HTML tags.
 */
export function containsHtml(text: string) {
  return text.includes('<')
}
